import { Controller } from '@hotwired/stimulus'

// Flash controller for auto-dismissing flash messages
// Usage: <div data-controller="flash" data-flash-duration-value="5000">
export default class extends Controller {
  static values = {
    duration: { type: Number, default: 5000 }
  }

  connect () {
    // Add entrance animation
    this.element.classList.add('animate-fade-in')

    // Set up auto-dismiss
    if (this.durationValue > 0) {
      this.dismissTimeout = setTimeout(() => {
        this.dismiss()
      }, this.durationValue)
    }
  }

  disconnect () {
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout)
    }
  }

  dismiss () {
    // Add exit animation
    this.element.classList.add('animate-fade-out')

    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  // Pause auto-dismiss on hover
  pause () {
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout)
    }
  }

  // Resume auto-dismiss on mouse leave
  resume () {
    if (this.durationValue > 0) {
      this.dismissTimeout = setTimeout(() => {
        this.dismiss()
      }, this.durationValue)
    }
  }
}
